import { Component, inject, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';

import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { StorageService } from '../_services/storage.service';
@Component({
  selector: 'app-rightmenu',
  imports: [FormsModule, DropdownModule, SidebarModule, ButtonModule],
  standalone: true,
  templateUrl: './app.rightmenu.component.html'
})
export class AppRightmenuComponent implements OnInit {
  selectedAmount!: SelectItem;
  fullName: string = '';
  position: string = '';

  constructor(public layoutService: LayoutService) { }

  storageService = inject(StorageService);
  route = inject(Router);

  ngOnInit() {
    this.profilePicture();
  }
  get visible(): boolean {
    return this.layoutService.state.rightMenuVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.rightMenuVisible = _val;
  }
  closeSidebar() {
    this.visible = false;
  }

  navToEditeProfile() {
    this.route.navigate([`user-profile/user-profile`]);
    this.closeSidebar();
  }

  navToChangePass() {
    this.route.navigate([`user-profile/change-pass`]);
    this.closeSidebar();
  }

  /** ออกจากระบบ = ล้าง session ที่นี่ (หน้า login ไม่ล้างให้แล้วถ้ายัง login อยู่) */
  navToLogout() {
    this.storageService.clean();
    this.route.navigate([`/login`]);
    this.closeSidebar();
  }

  profilePicture() {
    const user = this.storageService.getUser();
    this.fullName = user.fullName;
    this.position = user.position;
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }
}
